var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3334C12.3012 18.3334 14.3845 17.4007 15.8925 15.8926C17.4006 14.3846 18.3333 12.3012 18.3333 10.0001C18.3333 7.69891 17.4006 5.61558 15.8925 4.10752C14.3845 2.59949 12.3012 1.66675 10 1.66675C7.69883 1.66675 5.6155 2.59949 4.10744 4.10752C2.59941 5.61558 1.66667 7.69891 1.66667 10.0001C1.66667 12.3012 2.59941 14.3846 4.10744 15.8926C5.6155 17.4007 7.69883 18.3334 10 18.3334Z",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.9269V10.2603C11.3807 10.2603 12.5 9.14096 12.5 7.76025C12.5 6.37955 11.3807 5.26025 10 5.26025C8.61929 5.26025 7.5 6.37955 7.5 7.76025",
    stroke: "#323232",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.2939C10.1889 14.2941 10.3421 14.4472 10.3421 14.6357C10.3419 14.8242 10.1888 14.9774 10.0003 14.9775C9.81174 14.9775 9.6587 14.8243 9.65853 14.6357C9.65853 14.447 9.81163 14.2939 10.0003 14.2939Z",
    fill: "#323232",
    stroke: "#323232",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2256fea167fd7f604941f2e0f8355c75.svg";
export { ForwardRef as ReactComponent };